function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icons/Custom/House");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Icons/Custom/House",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.2596495,31.9108543 C23.2596495,30.5923618 23.2596495,29.5554807 23.2596495,28.8002111 C23.2596495,28.1425898 23.2431986,27.1821629 23.2102968,25.9189304 C23.196256,25.3796468 22.7569916,24.9487094 22.2175381,24.9449859 C21.4876467,24.9399479 20.8355366,24.9374289 20.2612077,24.9374289 C19.622735,24.9374289 18.8726562,25.0495232 18.0109713,25.2737117 C17.5703333,25.388357 17.2627658,25.786185 17.2627658,26.241493 L17.2627658,31.9445723 C15.601179,32.0651967 13.6229613,32.2647402 11.3281126,32.543203 C11.3272781,32.5433043 11.3264435,32.5434045 11.3256088,32.5435036 C10.7771656,32.6086501 10.2797529,32.2168607 10.2146064,31.6684176 L9.02155334,21.6243481 C8.97586789,21.2397399 8.71219865,20.9160988 8.34476219,20.7936199 L7.59992864,20.5453421 C7.47070937,20.502269 7.35329325,20.4297018 7.25697889,20.3333875 C6.91434037,19.990749 6.91434037,19.4352221 7.25697889,19.0925836 L19.0566667,7.2928958 C19.4300638,6.91949867 20.0294333,6.90078663 20.4253951,7.25016472 L33.5965487,18.8717708 C33.7442803,19.0021222 33.8489611,19.1742493 33.896745,19.3653848 C34.0270794,19.8867228 33.7101085,20.4150076 33.1887706,20.5453421 L32.0923016,20.8194593 C31.6747227,20.9238541 31.3707952,21.2837428 31.3377827,21.7129053 L30.6559937,30.5761624 C30.653895,30.6034454 30.6512366,30.6306825 30.6480202,30.6578565 C30.5181849,31.7547717 29.5237072,32.5387449 28.4267926,32.4089045 C26.4464886,32.1745079 24.7241076,32.0084911 23.2596495,31.9108543 Z",
  id: "Combined-Shape",
  stroke: "#EFCEA3",
  strokeWidth: 1.5,
  fill: "#FCF6E3"
}));

var SvgYellowHouse = function SvgYellowHouse(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYellowHouse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/yellow-house.7028f056.svg";
export { ForwardRef as ReactComponent };